import { Avatar, Layout, Popover, Row } from "antd";
import "../ScreenRedcross/DefaultEproScreen.css";
import React, { useEffect, useMemo } from "react";
import { UserOutlined } from "@ant-design/icons";
import useAuthRedcross from "../../hooks/useAuthRedcross";
import PetitionScreen from "./Petition/PetitionScreen";
import AnnounceScreen from "./Announce/AnnounceScreen";
import { AnimatePresence, motion } from "framer-motion";
import AVLA from "../../assets/ImageAddControl/AVLa.b.svg";
import AVLC from "../../assets/ImageAddControl/AVLc.svg";
import { GroupPermission } from "../../Context/AuthRedcrossContext";
import RegisterIndividualScreen from "../RegisterWolfScreen/RegisterIndividualScreen";
import RegisterLegalEntityScreen from "../RegisterWolfScreen/RegisterLegalEntityScreen";
import { SellerType } from "./DefaultEproModel";
import { ITodo } from "../../IRequestModel/IWorklistModel";
import CompanyDetials from "./CompanyDetials/CompanyDetials";
import { useUserContext } from "../../Context/UserContext";
import { useHistory, useLocation } from "react-router";
import { IoLogOutSharp, IoMailOutline, IoPersonOutline } from "react-icons/io5";
import { BsFillPersonFill } from "react-icons/bs";
import { LoginConfiguration } from "../../Services/ConfigurationService";
import Cookies from "universal-cookie";
import { clearLocalStorageOnLogout } from "../../Helper/localStoreFunction";
import { useSessionContext } from "../../Context/AuthContext";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import CompanyEditStatus from "./CompanyDetials/CompanyEditStatus";
import SupplierListProductScreen from "../SupplierECatalogScreen/SupplierListProductScreen";
import OrderHistory from "./OrderHistory/OrderHistory";
import TrackProductStatus from "./TrackProuctStatus/TrackProductStatus";
import SupplierMyProductScreen from "../SupplierMyProductScreen/SupplierMyProductScreen";
import ChangePasswordModal from "../../components/NavigationBar/ChangePasswordModal";
import { useForm } from "react-hook-form";
import { IChangePasswordRequest } from "../../IRequestModel/IChangePasswordModel";

type Props = {
  responeConfig: any;
};

const LayoutDefaultScreen: React.FC<Props> = ({ responeConfig }) => {
  const { Header, Content, Sider } = Layout;
  const { permission } = useAuthRedcross();
  const [activeSidebar, setActiveSidebar] = React.useState<string | null>(
    "petition"
  );
  const [userData] = useUserContext();
  const [popOverClick, setPopOverClick] = React.useState<boolean>(false);
  const location = useLocation();
  const history = useHistory();
  const [shortNameUser, setShortNameUser] = React.useState<string>("");
  const [isWolf, setIsWolf] = React.useState<boolean>(true);
  const cookies = new Cookies();
  const [sessionState, setSessionState] = useSessionContext();
  const { instance, accounts } = useMsal();
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const { t } = useTranslation(["translation"]);
  const [visible, setVisible] = React.useState(false);
  const [isPasswordCompared, setIsPasswordCompared] =
    React.useState<boolean>(true);
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      current_password: "",
      new_password: "",
      comfirm_password: "",
    },
  });

  useEffect(() => {
    window.onpopstate = (e) => {
      if (location.pathname === "/Supplier-portal") {
        history.replace("/Supplier-portal");
      }
    };
  }, [history]);

  useEffect(() => {
    if (userData) {
      initialNameUser();
    }
  }, [userData]);

  const initialNameUser = () => {
    if (userData) {
      let name = userData.NameEn || "";
      const fullName: any[] | ["", ""] = name.split(" ");
      let firstName = "";
      let lastName = "";
      for (let i = 0; i < fullName.length; i++) {
        if (i === 0) {
          firstName = fullName[i].slice(0, 1).toUpperCase();
        }
        if (i === 1) {
          lastName = fullName[i].slice(0, 1).toUpperCase();
        }
      }
      setShortNameUser(firstName + lastName);
    }
  };
  const handleCancel = () => {
    reset();
    setVisible(false);
  };

  const [workList, setWolkList] = React.useState<ITodo[]>();
  const handleSidebarClick = React.useCallback((key: string) => {
    setActiveSidebar(key);
  }, []);

  const onSubmitPassword = async (res: IChangePasswordRequest) => {
    console.log(res);
    if (res.new_password !== res.comfirm_password) {
      setIsPasswordCompared(false);
    } else {
      // setVisible(false);
      setIsPasswordCompared(true);
    }
  };

  const sidebar = permission?.sidebar.map((data, i) => {
    return (
      <div key={i}>
        <div
          style={{
            fontSize: "1.3rem",
            fontWeight: "bold",
            // marginBottom: "4px",
          }}
        >
          {data.name}
        </div>
        {data.sub.map((value, i) => {
          return (
            <div
              key={i}
              onClick={() => handleSidebarClick(value.key)}
              style={{
                color: activeSidebar === value.key ? "red" : "",
                cursor: "pointer",
                fontSize: "1.3rem",
                marginBottom: "6px",
              }}
            >
              &emsp;
              {value.name}
            </div>
          );
        })}
      </div>
    );
  });

  const signOutClickHandler = async (instance: any) => {
    var respone = await LoginConfiguration();
    const baseurl = window.location.origin.toString();
    cookies.remove("GuidVerify");
    clearLocalStorageOnLogout();
    setSessionState({ ...sessionState, isAuthenticated: false });
    //AzureLogout
    if (respone.type === "LoginAzure") {
      const logoutRequest = {
        account: instance.getAccountByHomeId(accounts[0]?.homeAccountId),
        postLogoutRedirectUri: `${baseurl}/login`,
      };
      await instance.logoutRedirect(logoutRequest);
    }
    setPopOverClick(false);

    //GoogleLogout
    // googleAuth?.signOut();
  };

  const handleOpenChangePasswordModal = () => {
    setVisible(true);
    setPopOverClick(false);
  };

  const userPopupContent = () => {
    return (
      <div className="main-user-popup-content">
        <div className="user-popup-content">
          <div className="user-popup-content-display">
            <IoPersonOutline className="icon-margin-top" />
            <p
              className="text-account-name icon-margin-left"
              style={{ fontSize: "20px" }}
            >
              {userData?.NameEn}
            </p>
          </div>
          <div className="user-popup-content-display">
            <IoMailOutline className="icon-margin-top " />
            <p
              className="text-account-mail icon-margin-left"
              style={{ fontSize: "20px" }}
            >
              {userData?.Email}
            </p>
          </div>
        </div>

        <div
          className="popup-container"
          onClick={handleOpenChangePasswordModal}
        >
          <div className="circle">
            <svg
              width="13"
              height="13"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.375 0.515625C11.4374 0.515648 10.5124 0.731471 9.6716 1.14638C8.83081 1.56129 8.09679 2.16415 7.52639 2.90828C6.95599 3.65241 6.56452 4.51784 6.38229 5.43756C6.20005 6.35727 6.23195 7.30659 6.4755 8.212L0.515625 14.1719V18.4844H4.82812V16.3281H6.98438V14.1719H9.14062L10.7937 12.5188C11.3098 12.6596 11.8403 12.7315 12.375 12.7344C13.9953 12.7344 15.5493 12.0907 16.695 10.945C17.8407 9.79925 18.4844 8.24531 18.4844 6.625C18.4844 5.00469 17.8407 3.45075 16.695 2.30502C15.5493 1.15929 13.9953 0.515625 12.375 0.515625Z"
                fill="black"
                stroke="black"
                stroke-width="0.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p className="text-logout">{t("Change Password")}</p>
        </div>

        <div className="popup-button-box">
          {/* change Pass */}
          <div
            className="popup-container"
            onClick={() => signOutClickHandler(instance)}
          >
            <div className="circle">
              <IoLogOutSharp />
            </div>
            <p className="text-logout">{t("Logout")}</p>
          </div>
        </div>
      </div>
    );
  };

  const handleClickChange = (visible: boolean) => {
    setPopOverClick(visible);
  };

  return (
    <Layout style={{ minHeight: "100vh", overflow: "hidden" }}>
      <Header className="header">
        <Row>
          <img
            className="img-logo"
            src={responeConfig?.pathLogoNav}
            alt="logo"
            style={{ width: responeConfig?.cssConfig?.width }}
          />
        </Row>
        {permission && (
          <div className="permission-container">
            <div className="permission-item">
              {permission.group === GroupPermission.AVLC ? (
                <img src={AVLC} alt="logo" />
              ) : permission.group === GroupPermission.Pending ? null : (
                <img src={AVLA} alt="logo" />
              )}
              <span className="permission-text">
                {permission.group != GroupPermission.Pending
                  ? permission.group.slice(0, 3) +
                    "-" +
                    permission.group.slice(3)
                  : permission.group}
              </span>
            </div>
            <div className="profile-container desktop">
              <Popover
                placement="bottomRight"
                content={userPopupContent}
                trigger="click"
                visible={popOverClick}
                onVisibleChange={handleClickChange}
                overlayInnerStyle={{ borderRadius: "6px" }}
              >
                <div className="profile-button">
                  <p className="profile-name">{shortNameUser}</p>
                </div>
              </Popover>
            </div>
          </div>
        )}
      </Header>
      <Layout style={{ marginTop: "70px" }}>
        <Sider width={300} className="side-bars">
          {sidebar}
        </Sider>
        <Layout className="layout-content">
          <Content className="site-content">
            <AnimatePresence exitBeforeEnter>
              <motion.div
                layout
                style={{ minHeight: "100%" }}
                key={activeSidebar}
                initial={{ x: 10, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -10, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                {activeSidebar === "petition" && (
                  <PetitionScreen setWolkList={setWolkList} />
                )}
                {activeSidebar === "order-history" && <OrderHistory />}
                {activeSidebar === "announce" && <AnnounceScreen />}
                {activeSidebar === "tracking-product-status" && (
                  <TrackProductStatus />
                )}
                {activeSidebar === "company-details" && (
                  <CompanyDetials permission={permission?.sellerType} />
                )}
                {activeSidebar === "new-products" && (
                  <SupplierListProductScreen />
                )}
                {activeSidebar === "my-products" && <SupplierMyProductScreen />}
              </motion.div>
            </AnimatePresence>
          </Content>
        </Layout>
      </Layout>
      <ChangePasswordModal
        {...{
          control,
          errors,
          handleCancel,
          handleSubmit,
          isPasswordCompared,
          onSubmitPassword,
          visible,
        }}
      />
    </Layout>
  );
};

export default LayoutDefaultScreen;
